import { sendWhatsAppMessage } from '@/lib/services/whatsapp';

// Custom SMS provider for Firebase Phone Authentication
export class WhatsAppSMSProvider {
  private app: any;
  private language: 'en' | 'ar';

  constructor(app: any, language: 'en' | 'ar' = 'en') {
    this.app = app;
    this.language = language;
  }

  async sendSMS(phoneNumber: string, code: string): Promise<void> {
    try {
      console.log('📱 [WhatsApp SMS Provider] Sending code via WhatsApp to:', phoneNumber);
      
      // Format phone number for WhatsApp (remove + and country code)
      const formattedPhone = this.formatPhoneForWhatsApp(phoneNumber);
      console.log('📱 [WhatsApp SMS Provider] Formatted phone for WhatsApp:', formattedPhone);
      
      // Create the message
      const message = this.createOTPMessage(code);
      console.log('📱 [WhatsApp SMS Provider] Message content:', message);
      
      // Send via WhatsApp
      const result = await sendWhatsAppMessage(formattedPhone, message);
      
      if (!result.success) {
        console.error('❌ [WhatsApp SMS Provider] Failed to send WhatsApp message:', result.error);
        throw new Error(`WhatsApp send failed: ${result.error}`);
      }
      
      console.log('✅ [WhatsApp SMS Provider] WhatsApp message sent successfully');
    } catch (error) {
      console.error('❌ [WhatsApp SMS Provider] Error in sendSMS:', error);
      throw error;
    }
  }

  private formatPhoneForWhatsApp(phoneNumber: string): string {
    // Remove + and any non-digit characters
    let cleaned = phoneNumber.replace(/\D/g, '');
    
    // If it starts with 966 (Saudi Arabia), remove it and add 0
    if (cleaned.startsWith('966')) {
      cleaned = '0' + cleaned.substring(3);
    }
    
    // Ensure it starts with 0 and has 10 digits
    if (!cleaned.startsWith('0')) {
      cleaned = '0' + cleaned;
    }
    
    // Limit to 10 digits
    cleaned = cleaned.slice(0, 10);
    
    return cleaned;
  }

  private createOTPMessage(code: string): string {
    if (this.language === 'ar') {
      return `رمز التحقق الخاص بك هو: ${code}\n\nهذا الرمز صالح لمدة 10 دقائق.\n\nمنصة نمط`;
    } else {
      return `Your verification code is: ${code}\n\nThis code is valid for 10 minutes.\n\nNamat Platform`;
    }
  }
}

// Factory function to create the SMS provider
export function createWhatsAppSMSProvider(app: any, language: 'en' | 'ar' = 'en') {
  return new WhatsAppSMSProvider(app, language);
}
